import LiveItem from "./live-item";
import { apiFetch } from "../../services/api-fetch";
import { init as initImg } from "../../services/picture-fallback";

const initNewItems = () => {
  let items = Array.from(document.querySelectorAll('[data-live]'));
  items = items.filter(item => !item.liveItem);

  items.forEach(item => new LiveItem(item));
}

const liveInit = () => {
  let liveContainer = document.getElementById('live');
  if (!liveContainer) return;

  let loadAction = liveContainer.dataset.action;
  if (!loadAction) return;

  apiFetch(loadAction, { method: "GET" })
    .then(res => {
      if (res.success) {
        liveContainer.innerHTML = res.html;

        liveContainer.querySelectorAll("picture img")
        .forEach(initImg);

        initNewItems();
        
        document.body.addEventListener("update.live", () => initNewItems());
        document.body.classList.add('live-visible');
      }
    })

  
};

export { liveInit };